import { ArrowUpRightIcon } from '@heroicons/react/16/solid';
import { twMerge } from 'tailwind-merge';
import { viewInExplorerTooltip } from '../../lib/tooltips';
import { ClipboardButton } from '../ClipboardButton/ClipboardButton';
import { Tooltip } from '../Tooltip/Tooltip';

export type HexValueProps = {
  value: `0x${string}`;
  explorerHref?: string;
  truncate?: boolean;
  truncateLength?: {
    prefix: number;
    suffix: number;
  };
  className?: string;
  showLinkIcon?: boolean;
  showCopyButton?: boolean;
};

/**
 * A component for displaying truncated hex values with a copy-to-clipboard button.
 */
export const HexValue: React.FC<HexValueProps> = ({
  value,
  explorerHref,
  truncate = true,
  truncateLength = { prefix: 6, suffix: 0 },
  className = '',
  showLinkIcon = false,
  showCopyButton = true,
}) => {
  const displayValue = truncate
    ? `${value.slice(0, truncateLength.prefix)} ${truncateLength.suffix ? `...${value.slice(-truncateLength.suffix)}` : ''}`
    : value;

  return (
    <div className={twMerge('flex items-center space-x-0.5', className)}>
      {explorerHref ? (
        <Tooltip content={viewInExplorerTooltip()}>
          <a
            href={explorerHref}
            target="_blank"
            className="flex gap-0.5 text-contentSecondary hover:brightness-125"
          >
            {displayValue}
            {showLinkIcon && <ArrowUpRightIcon className="size-3" />}
          </a>
        </Tooltip>
      ) : (
        <span>{displayValue}</span>
      )}
      {showCopyButton && <ClipboardButton text={value} />}
    </div>
  );
};
